<section class="workspace-page workspace-page--full">
  <header class="workspace-page__heading">
    <h1 class="workspace-page__title">Report templates</h1>
    <a class="br-btn br-btn--primary br-btn--sm" routerLink="/overview/templates/new"
       [hidden]="!auth.hasPermission('Company.Manage')">New template</a>
  </header>
  <!-- Each template's controls sit together: its actions menu, then the toggle that lists the reports it generated. -->
  <ng-container *workspaceView="'full'">
    <div class="workspace-page__body workspace-page__body--contained">
      <app-data-table #table class="workspace-page__panel" [columns]="columns" [fetch]="fetch" [(search)]="search"
                      searchPlaceholder="Find a template…" columnPickerKey="report-templates" [resizableColumns]="true"
                      [rowActions]="templateActions" [rowDetail]="templateReports" emptyText="No templates match.">
        <ng-template dtCell="name" let-row><a [routerLink]="['/overview/templates', row.id, 'generate']">{{ row.name }}</a></ng-template>
        <ng-template dtCell="description" let-row>{{ row.description || '—' }}</ng-template>
        <ng-template dtCell="source" let-row>{{ row.isSystem ? 'System' : 'Company' }}</ng-template>
        <ng-template dtCell="status" let-row>{{ row.isActive ? 'Active' : 'Archived' }}</ng-template>
        <ng-template dtCell="createdAt" let-row>{{ row.createdAt | date:'MMM d, y' }}</ng-template>
        <ng-template dtCell="updatedAt" let-row>{{ row.updatedAt | date:'MMM d, y' }}</ng-template>
      </app-data-table>
    </div>
  </ng-container>
  <ng-container *workspaceView="'compact'">
    <app-data-list #list [fetch]="fetch" [(search)]="search" [trackByFn]="trackById" [sortOptions]="sortOptions"
                   searchPlaceholder="Find a template…" emptyText="No templates match.">
      <ng-template dataListItem let-row>
        <div class="br-flex br-gap-2">
          <div class="br-min-w-0 br-flex-grow-1">
            <strong>{{ row.name }}</strong>
            <div class="br-text-muted">{{ row.isSystem ? 'System' : 'Company' }} · {{ row.isActive ? 'Active' : 'Archived' }} · {{ row.reportCount }} {{ row.reportCount === 1 ? 'report' : 'reports' }}</div>
          </div>
          <ng-container *ngTemplateOutlet="templateActions; context: { $implicit: row }"></ng-container>
        </div>
      </ng-template>
      <ng-template dataListDetail let-row>
        <p *ngIf="row.description">{{ row.description }}</p>
        <ng-container *ngTemplateOutlet="templateReports; context: { $implicit: row }"></ng-container>
      </ng-template>
    </app-data-list>
  </ng-container>
</section>

<!-- The row's own buttons, beside its expand toggle. Archive lives on the template page.
     A disabled button takes no pointer events, so its wrapper carries the reason. -->
<ng-template #templateActions let-row>
  <span [matTooltip]="row.isActive ? 'Generate report' : 'Archived templates cannot generate reports. Restore it first.'">
    <button type="button" mat-icon-button [disabled]="!row.isActive" [routerLink]="['/overview/templates', row.id, 'generate']"
            aria-label="Generate report"><br-icon>note_add</br-icon></button>
  </span>
  <button *ngIf="auth.hasPermission('Company.Manage')" type="button" mat-icon-button
          [matTooltip]="row.isSystem ? 'Customize' : 'Edit'" [attr.aria-label]="row.isSystem ? 'Customize' : 'Edit'"
          [routerLink]="['/overview/templates', row.id, 'edit']"><br-icon>edit</br-icon></button>
</ng-template>

<!-- The reports a template generated, in the shared list; it loads when the template is expanded. -->
<ng-template #templateReports let-row>
  <app-data-list class="data-list--inline data-list--plain" [fetch]="reports(row.id)" [searchable]="false"
                 [contextKey]="'template-reports:' + row.id"
                 [pageSize]="10" [trackByFn]="trackById" emptyText="No reports from this template yet.">
    <ng-template dataListItem let-report>
      <a [routerLink]="['/overview', 'reports', report.id]" [state]="returnState()">{{ report.title }}</a>
      <div class="br-small br-text-muted">{{ reportPeriod(report) }} · Updated {{ report.updatedAt | date:'MMM d, y' }}</div>
    </ng-template>
  </app-data-list>
</ng-template>
